import request from '@/utils/requestTeacher'

export function login(data) {
  return request({
    url: '/teacher/login',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/teacher/exit',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/teacher/info',
    method: 'post',
    data
  })
}

export function updatePassword(data) {
  return request({
    url: '/teacher/update/password',
    method: 'post',
    data
  })
}

export function saveUserSetting(data) {
  return request({
    url: '/teacher/setting/save',
    method: 'post',
    data
  })
}

export function getUserSetting(data) {
  return request({
    url: '/teacher/setting/data',
    method: 'post',
    data
  })
}

export function getLeaveList(data) {
  return request({
    url: '/teacher/leave/list',
    method: 'post',
    data
  })
}

export function auditLeave(data) {
  return request({
    url: '/teacher/leave/audit',
    method: 'post',
    data
  })
}

export function deleteLeave(data) {
  return request({
    url: '/teacher/leave/delete',
    method: 'post',
    data
  })
}

export function getTeacherData(data) {
  return request({
    url: '/teacher/total/data',
    method: 'post',
    data
  })
}

export function getTeacherClassTimesList(data) {
  return request({
    url: '/teacher/class/time/list',
    method: 'post',
    data
  })
}

export function joinOnlineRoom(data) {
  return request({
    url: '/teacher/join/online/room',
    method: 'post',
    data
  })
}

export function getRoomRecordList(data) {
  return request({
    url: '/teacher/room/record/list',
    method: 'post',
    data
  })
}

export function getClassTotalList(data) {
  return request({
    url: '/teacher/class/total/list',
    method: 'post',
    data
  })
}

export function getClassCallList(data) {
  return request({
    url: '/teacher/class/call/list',
    method: 'post',
    data
  })
}

export function saveClassCallData(data) {
  return request({
    url: '/teacher/class/call/update',
    method: 'post',
    data
  })
}

export function getClassCallStudentList(data) {
  return request({
    url: '/teacher/class/call/students',
    method: 'post',
    data
  })
}

export function getDayTotal(data) {
  return request({
    url: '/teacher/day/class/total',
    method: 'post',
    data
  })
}

export function getClassWorkList(data) {
  return request({
    url: '/teacher/class/work/list',
    method: 'post',
    data
  })
}

export function deleteClassWork(data) {
  return request({
    url: '/teacher/class/work/delete',
    method: 'post',
    data
  })
}

export function saveClassWork(data) {
  return request({
    url: '/teacher/class/work/save',
    method: 'post',
    data
  })
}

export function getWorkClassTimeList(data) {
  return request({
    url: '/teacher/class/work/time/list',
    method: 'post',
    data
  })
}

export function updateClassWork(data) {
  return request({
    url: '/teacher/class/work/update',
    method: 'post',
    data
  })
}

export function editClassWork(data) {
  return request({
    url: '/teacher/class/work/edit',
    method: 'post',
    data
  })
}

export function TaskInfo(data) {
  return request({
    url: '/teacher/class/work/info',
    method: 'post',
    data
  })
}

export function StudentTaskList(data) {
  return request({
    url: '/teacher/class/work/student/list',
    method: 'post',
    data
  })
}

export function studentWorkInfo(data) {
  return request({
    url: '/teacher/class/work/student/info',
    method: 'post',
    data
  })
}

export function saveWorkComment(data) {
  return request({
    url: '/teacher/class/work/student/remark',
    method: 'post',
    data
  })
}

export function saveTeacherClassTime(data) {
  return request({
    url: 'admin/teacher/class/time/save',
    method: 'post',
    data
  })
}

export function getTeacherClassTime(data) {
  return request({
    url: 'admin/teacher/class/time/list',
    method: 'post',
    data
  })
}

export function deleteTeacherClassTime(data) {
  return request({
    url: 'admin/teacher/class/time/delete',
    method: 'post',
    data
  })
}

export function cancelReservation(data) {
  return request({
    url: 'admin/teacher/class/time/cancel',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/teacher/index.js